/*
 * Maison Avéla — expected delivery date.
 *
 * Orders placed before 16:00 on a working day ship the same day and are
 * delivered the next working day. Everything is computed in Europe/Sofia
 * regardless of the shopper's own timezone, and Bulgarian public holidays
 * are treated as non-working days so the promise stays truthful.
 *
 * Wording: "утре" only when delivery really is the next calendar day —
 * which in practice means a weekday order. Anything further out is named
 * by its weekday ("в понеделник", "във вторник"), because a date three
 * days away is easier to picture as a day of the week than as a count.
 */
(function () {
  'use strict';

  var CUTOFF_HOUR = 16;

  // Official non-working days in Bulgaria, including the Monday/Tuesday
  // shifts for holidays that fall on a weekend.
  var HOLIDAYS = {
    '2026-01-01': 1,
    '2026-03-03': 1,
    '2026-04-10': 1,
    '2026-04-11': 1,
    '2026-04-12': 1,
    '2026-04-13': 1,
    '2026-05-01': 1,
    '2026-05-06': 1,
    '2026-05-24': 1,
    '2026-05-25': 1,
    '2026-09-06': 1,
    '2026-09-07': 1,
    '2026-09-22': 1,
    '2026-12-24': 1,
    '2026-12-25': 1,
    '2026-12-26': 1,
    '2026-12-28': 1,
    '2027-01-01': 1,
    '2027-03-03': 1,
    '2027-04-30': 1,
    '2027-05-01': 1,
    '2027-05-02': 1,
    '2027-05-03': 1,
    '2027-05-04': 1,
    '2027-05-06': 1,
    '2027-05-24': 1,
    '2027-09-06': 1,
    '2027-09-22': 1,
    '2027-12-24': 1,
    '2027-12-25': 1,
    '2027-12-26': 1,
    '2027-12-27': 1,
    '2027-12-28': 1
  };

  var WEEKDAYS = [
    'неделя',
    'понеделник',
    'вторник',
    'сряда',
    'четвъртък',
    'петък',
    'събота'
  ];

  var MONTHS = [
    'януари',
    'февруари',
    'март',
    'април',
    'май',
    'юни',
    'юли',
    'август',
    'септември',
    'октомври',
    'ноември',
    'декември'
  ];

  function sofiaNow() {
    var parts;
    try {
      parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Sofia',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }).formatToParts(new Date());
    } catch (error) {
      return null;
    }

    var map = {};
    parts.forEach(function (part) {
      map[part.type] = part.value;
    });

    var hour = parseInt(map.hour, 10);
    if (hour === 24) hour = 0;

    return {
      utc: Date.UTC(parseInt(map.year, 10), parseInt(map.month, 10) - 1, parseInt(map.day, 10)),
      hour: hour,
      minute: parseInt(map.minute, 10)
    };
  }

  function key(utc) {
    var d = new Date(utc);
    var m = d.getUTCMonth() + 1;
    var day = d.getUTCDate();
    return d.getUTCFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (day < 10 ? '0' + day : day);
  }

  function isWorkingDay(utc) {
    var weekday = new Date(utc).getUTCDay();
    if (weekday === 0 || weekday === 6) return false;
    return !HOLIDAYS[key(utc)];
  }

  function nextWorkingDay(utc) {
    var next = utc;
    for (var i = 0; i < 30; i++) {
      next += 86400000;
      if (isWorkingDay(next)) return next;
    }
    return next;
  }

  function label(utc, todayUtc) {
    var diff = Math.round((utc - todayUtc) / 86400000);
    var d = new Date(utc);
    var date = d.getUTCDate() + ' ' + MONTHS[d.getUTCMonth()];

    if (diff === 1) return 'утре, ' + date;

    var weekday = WEEKDAYS[d.getUTCDay()];
    // "във вторник", not "в вторник".
    var preposition = weekday.charAt(0) === 'в' || weekday.charAt(0) === 'ф' ? 'във ' : 'в ';
    return preposition + weekday + ', ' + date;
  }

  function render() {
    var nodes = document.querySelectorAll('[data-ma-eta]');
    if (!nodes.length) return;

    var now = sofiaNow();
    if (!now) return;

    var today = now.utc;
    var shipsToday = isWorkingDay(today) && now.hour < CUTOFF_HOUR;
    var shipDay = shipsToday ? today : nextWorkingDay(today);
    var deliveryDay = nextWorkingDay(shipDay);

    var text = 'Получаваш го ' + label(deliveryDay, today);

    var hint = '';
    if (shipsToday) {
      var minutesLeft = (CUTOFF_HOUR - now.hour) * 60 - now.minute;
      var hours = Math.floor(minutesLeft / 60);
      var minutes = minutesLeft % 60;
      if (hours > 0) {
        hint = 'Поръчай в следващите ' + hours + ' ч ' + minutes + ' мин';
      } else if (minutes > 0) {
        hint = 'Поръчай в следващите ' + minutes + ' мин';
      }
    } else {
      hint = 'Изпращаме в следващия работен ден';
    }

    nodes.forEach(function (node) {
      var textEl = node.querySelector('[data-ma-eta-text]');
      var hintEl = node.querySelector('[data-ma-eta-hint]');
      if (textEl) textEl.textContent = text;
      if (hintEl) hintEl.textContent = hint;
    });
  }

  function boot() {
    render();
    // Keep the countdown honest if the tab stays open past the cutoff.
    window.setInterval(render, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', render);
  window.addEventListener('pageshow', render);
})();